// InnerHeader.jsx
import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line

import belediyeBinasi from "images/yenimahalle/belediyeBinasi.jpg";

const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover`}
  background-image: url(${belediyeBinasi});
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-800 opacity-50`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const TwoColumn = tw.div`pt-24 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;

const Heading = styled.h1`
  ${tw`pl-0 md:pl-10 text-3xl text-center md:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-primary-500 px-4 -mx-4 py-2`}
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;

/**
 * @param {Object} props
 * @param {string} props.headingLine1 - İlk satırın metni
 * @param {string} props.headingLine2 - İkinci satırın metni (SlantedBackground içinde görünecek)
 */
export default function InnerHeader({
  headingLine1 = "",
  headingLine2 = ""
}) {
  return (
    <Container>
      <OpacityOverlay />
      <HeroContainer>
        <TwoColumn>
          <LeftColumn>
            <Heading>
              {headingLine1 &&
                <span>{headingLine1}</span>
              }
              {headingLine2 && (
                <>
                  <br />
                  <SlantedBackground>{headingLine2}</SlantedBackground>
                </>
              )}
            </Heading>
          </LeftColumn>
        </TwoColumn>
      </HeroContainer>
    </Container>
  );
}
